<template>
  <v-container fluid ma-0 pa-0>
    <gh-tabs-page :tabs="tabs" v-model="activatedTab" :show-tabs="true">
      <template #page-0>
        <gh-table-page ref="table" :show-tabs="false" :args-query="argsQuery" :template-model="templateModel"
          module="mes.business.psm.batch.service" cls="BatchService" :before-save="beforeSave">
          <template #area_query>
            <v-layout column style="margin:0px;padding:0px;">
              <cascader-site v-model="something" @input="chnageStruct(struct)"></cascader-site>
              <v-layout row wrap style="margin:0px;padding:0px;">
                <gh-date-picker label="选择开始日期" v-model="argsQuery.startdate" :max="argsQuery.enddate"></gh-date-picker>
                <gh-date-picker label="选择结束日期" v-model="argsQuery.enddate" :min="argsQuery.startdate"></gh-date-picker>
                <v-spacer></v-spacer>
                <v-text-field v-model="argsQuery.keywords" counter :autofocus="true" clearable label="关键字"
                  append-icon="mdi-circle-edit-outline" @change="$refs.table.query()"></v-text-field>
              </v-layout>
            </v-layout>
          </template>
          <template #model-prop-StructureId="{prop,model}">
            <v-autocomplete :items="structures" label="生产车间" v-model="model.StructureId" browser-autocomplete
              return-object clearable item-text="Name" item-value="Id"></v-autocomplete>
          </template>
          <template #model-prop-PlanQty="{prop,model}">
            <v-text-field v-model="model.PlanQty" :label="prop.text" type="number" min="0"
              :rules="[()=>model.PlanQty>0 || '计划量需大于0']"></v-text-field>
          </template>
          <template #model-prop-MaterialId="{prop,model}">
            <v-autocomplete :items="materials" label="产品名称" v-model="model.MaterialId" browser-autocomplete
              return-object clearable item-text="Name" item-value="Id" :loading="matLoading">
              <template v-slot:item="materials">
                <v-list-tile-content>
                  <v-list-tile-title v-html="materials.item.Name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="materials.item.Ctrl+' ('+materials.item.Cd+')'">
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
              <template v-slot:append-outer>
                <v-btn color="secondary" flat icon small @click="get_materials">
                  <v-icon small>cached</v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </template>
          <template #table-cell-BatchStateId="{props}">
            <span>
              <font :color="states[props.BatchStateId]">{{props.BatchStateName}}</font>
            </span>
          </template>
          <template #table-cell-MaterialStateId="{props}">
            <span>
              <font :color="mixStates[props.MaterialStateId]">{{props.MaterialStateName}}</font>
            </span>
          </template>
          <template #table-cell-O-Actions="{props}">
            <v-layout row align-center>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon flat @click="$refs.table.copyItem(props)" v-on="on"
                    style="margin: 0px;width: 24px;height: 24px;">
                    <v-icon style="margin: 0px;" small>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>复制本记录</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon flat @click="$refs.table.editItem(props)" v-show="!statesLock[props.BatchStateId]"
                    v-on="on" style="margin: 0px;width: 24px;height: 24px;">
                    <v-icon style="margin: 0px;" small>edit</v-icon>
                  </v-btn>
                </template>
                <span>编辑本记录</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon flat @click="$refs.table.deleteItem(props)" v-show="!statesLock[props.BatchStateId]"
                    v-on="on" style="margin: 0px;width: 24px;height: 24px;">
                    <v-icon style="margin: 0px;" small>delete</v-icon>
                  </v-btn>
                </template>
                <span>删除本记录</span>
              </v-tooltip>
            </v-layout>
          </template>
          <template #table-cell-O-sort="{props}">
            <v-layout row align-center>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon flat @click="$refs.table.moveupItem(props)" color="success" v-show="props.Up" v-on="on"
                    style="margin: 0px;width: 24px;height: 24px;">
                    <v-icon style="margin: 0px;" small>mdi-arrow-up</v-icon>
                  </v-btn>
                </template>
                <span>上移</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon flat @click="move_pre_day(props)" color="success" v-show="props.Left" v-on="on"
                    style="margin: 0px;width: 24px;height: 24px;">
                    <v-icon style="margin: 0px;" small>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>移到前一天</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon flat @click="$refs.table.movedownItem(props)" color="success" v-show="props.Down"
                    v-on="on" style="margin: 0px;width: 24px;height: 24px;">
                    <v-icon style="margin: 0px;" small>mdi-arrow-down</v-icon>
                  </v-btn>
                </template>
                <span>下移</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon flat @click="move_next_day(props)" color="success" v-show="props.Right" v-on="on"
                    style="margin: 0px;width: 24px;height: 24px;">
                    <v-icon style="margin: 0px;" small>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
                <span>移到后一天</span>
              </v-tooltip>
            </v-layout>
          </template>
          <template #table-cell-Bom="{props}">
            <a style="color:green; font-style:italic;text-decoration:underline"
              @click="bom_view(props)">{{props.Bom}}</a>
          </template>
          <template #table-cell-Routing="{props}">
            <a style="color:blue;font-style:italic;text-decoration:underline"
              @click="routing_view(props)">{{props.Routing}}</a>
          </template>
        </gh-table-page>
      </template>
      <template #page-1>
        <gh-table-page ref="tableBom" :args-query="argsQueryBom" sort-by="MaterialCd" :show-tabs="false"
          module="mes.business.std.bom.service" cls="BomDetailService">
          <template #area_operation>
            <v-layout></v-layout>
          </template>
          <template #area_query>
            <v-layout row align-center>
              <div class="title font-weight-black">{{currentModel.MaterialName}}</div>
              <div>————</div>
              <div class="title font-weight-bold">{{currentModel.MaterialCtrl}}</div>
              <div>————</div>
              <div class="title font-weight-medium">{{currentModel.Batch}}</div>
              <v-spacer></v-spacer>
              <v-flex>
                <v-text-field v-model="argsQueryBom.keywords" counter :autofocus="true" clearable label="关键字"
                  append-icon="mdi-circle-edit-outline" @change="$refs.tableBom.query()"></v-text-field>
              </v-flex>
            </v-layout>
          </template>
        </gh-table-page>
      </template>
      <template #page-2>
        <gh-pdf :id="currentModel.RoutingFile"></gh-pdf>
      </template>
    </gh-tabs-page>
  </v-container>
</template>

<style scoped>
</style>

<script>
  import Batch from "./batch.ts";
  export default Batch;
</script>